import React from 'react';
import { motion } from 'framer-motion';
import { integrationCategories } from './data';
export function Integrations() {
  return <section id="integrations" className="bg-white py-20 md:py-28" data-id="element-95">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-96">
        <div className="max-w-2xl" data-id="element-97">
          <p className="text-xs font-semibold uppercase tracking-widest text-signal" data-id="element-98">
            Integrations
          </p>
          <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.05] tracking-tight md:text-6xl" data-id="element-99">
            Every tool your revenue team already uses.
          </h2>
          <p className="mt-5 text-lg text-ink/60" data-id="element-100">
            Connect once. oursignals keeps every source in sync and normalizes
            the data so it all speaks the same language.
          </p>
        </div>

        <div className="mt-14 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-101">
          {integrationCategories.map((cat, i) => <motion.div key={cat.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} data-id="element-102">
              <div className="flex items-center gap-2 border-b border-ink/15 pb-3" data-id="element-103">
                <cat.icon className="h-4 w-4 text-signal" data-id="element-104" />
                <h3 className="text-sm font-semibold uppercase tracking-widest text-ink/70" data-id="element-105">
                  {cat.label}
                </h3>
              </div>
              <ul className="mt-4 space-y-2.5" data-id="element-106">
                {cat.items.map((item, j) => <li key={`${cat.id}-${j}`} className="group flex items-center gap-3 rounded-lg px-2 py-2 transition-colors hover:bg-cream" data-id="element-107">
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-ink/15 bg-cream font-display text-sm font-semibold text-ink transition-colors group-hover:border-signal group-hover:text-signal" data-id="element-108">
                      {item.abbr}
                    </span>
                    <span className="font-medium text-ink/80" data-id="element-109">{item.name}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <p className="mt-12 text-sm text-ink/50" data-id="element-110">
          …and 40+ more. Missing something?{' '}
          <a href="#cta" className="font-semibold text-signal hover:underline" data-id="element-111">
            Request an integration
          </a>
          .
        </p>
      </div>
    </section>;
}